import { gql } from 'graphql-tag';

const projectTotalsFragment = gql`
  fragment ProjectTotalsFragment on Project {
    id
    allocationsTotals(
      allocationStatusList: $allocationStatusList
      filter: $filter
    ) {
      totalHours
      totalCost {
        amount
        currency {
          id
          symbol
          name
        }
      }
    }
    resourceRequestsTotals(
      requestStatusList: $requestStatusList
      filter: $filter
    ) {
      totalHours
      totalCost {
        amount
        currency {
          id
          symbol
          name
        }
      }
    }
  }
`;

export default projectTotalsFragment;
